import {
  Paragraph, VectorTick, View,
  XStack
} from '@ninjacart/nc-nk-ui';
import { ChevronRight } from '@tamagui/lucide-icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Define the props interface
interface ReportProfileProps {
  currentIndex: number;
  unFollowApiCall: () => void;
}

export function ReportProfile({ currentIndex, unFollowApiCall }: ReportProfileProps) {
  const [showImage, setShowImage] = useState(false);
  const { t } = useTranslation();

  const handleClick = (item: string) => {
    if (item !== t('page.unFollow')) {
      setShowImage((prevState) => !prevState);
    } else {
      unFollowApiCall();
    }
  };

  const reportList = [t('page.report'), t('page.block'), t('page.unFollow')];

  useEffect(() => {
    setShowImage(false);
  }, [currentIndex]);

  return (
    <>
      {!showImage ? (
        <View paddingHorizontal={20} marginTop={10}>
          {reportList.map((item, index) => (
            <XStack
              key={index}
              flexDirection={'row'}
              justifyContent={'space-between'}
              onPress={() => handleClick(item)}
              testID='kisan_tId_reportProfile'
              // Adding role="button" and aria-label for accessibility
              role="button"
              aria-label={item}
            >
              <Paragraph marginBottom={30} fontSize={16} fontWeight={'500'} color={'$usertextColor'}>
                {item}
              </Paragraph>
              <ChevronRight />
            </XStack>
          ))}
        </View>
      ) : (
        <View justifyContent={'center'} alignItems={'center'} marginTop={10}>
          <VectorTick width={70} height={70} />
          <View marginTop={20}>
            <Paragraph fontSize={18} fontWeight={'600'} marginBottom={10} textAlign={'center'}>
              {t('page.thanksForLettingUsKnow')}
            </Paragraph>
            <Paragraph
              fontSize={13}
              fontWeight={'400'}
              marginBottom={10}
              textAlign={'center'}
              // Assuming currentIndex should not be null
              style={{ display: currentIndex !== null ? 'none' : 'block' }}
            >
              {t('page.yourFeedbackIsImportantInHelpingUsKeep')}
            </Paragraph>
          </View>
        </View>
      )}
    </>
  );
}
